<template>
  <div class="homePage">
    <a-spin :spinning="spinning">
      <!-- banner -->
      <div class="homePage-img">
        <a-carousel arrows autoplay style="width: 70%; margin: auto">
          <div
            slot="prevArrow"
            slot-scope="props"
            style="left: 10px; z-index: 1"
          >
            <div
              style="
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 30px;
                opacity: 0.5;
              "
            >
              <a-icon style="color: #000" type="left-circle" />
            </div>
          </div>
          <div
            slot="nextArrow"
            slot-scope="props"
            style="
              width: 40px;
              height: 40px;
              background-color: #fff;
              margin-right: 40px;
              border-radius: 30px;
              opacity: 0.5;
            "
          >
            <a-icon style="color: #000" type="left-circle" />
          </div>
          <div v-for="banner in imageStr">
            <img
              :src="banner.displayUrl"
              style="width: 100%; height: 300px; cursor: pointer; margin: auto"
              @click="starRunLive(banner.targetUrl, banner.id)"
            />
          </div>
        </a-carousel>
      </div>
      <div class="homePage-list">
        <div class="homePage-list-div">
          <div class="homePage-list-div-top" style="margin-top: 10px">
            <!--   字   -->
            <div class="font">
              <span class="font-live">直播</span>
              <div class="font-div"></div>
              <span class="font-eng">Live</span>
            </div>
            <!-- list-->
            <div class="homePage-list-div-list">
              <div
                v-for="(item, index) in cardList"
                class="homePage-list-div-list-card"
                @click="roomBtn_link(item.target_url)"
              >
                <div style="min-height: 135px; position: relative">
                  <img :src="item.cover_url" class="list-img" />
                  <div
                    class="list-time"
                    style="
                      position: absolute;
                      top: 0px;
                      color: white;
                      display: flex;
                      justify-content: right;
                    "
                  >
                    <!-- (1)series: 系列
                         single: 普通直播
                                   ----------判断sort-time的23:59:59

                         (2)convention: 多会场（九宫格会议）
                                   ----------判断end_data的23：59：59
                         -->
                    <span
                      v-if="item.type === 'series' || item.type === 'single'"
                      style="display: flex"
                    >
                      <span
                        v-if="
                          new Date().valueOf() >
                            new Date(
                              transitionDate(item.sort_time)
                            ).valueOf() &&
                          new Date().valueOf() <
                            moment(item.sort_time).endOf('day').valueOf()
                        "
                      >
                        <!--正在直播-->
                        <img
                          :src="imgOne"
                          alt=""
                          class="icon"
                          style="margin-top: 2px; color: #dadada"
                        />
                      </span>
                      <span
                        v-if="
                          new Date().valueOf() <=
                          new Date(transitionDate(item.sort_time)).valueOf()
                        "
                      >
                        <!--倒计时-->
                        <img
                          :src="imgs"
                          alt=""
                          class="icon"
                          style="margin-top: 2px; color: #dadada; float: left"
                        />
                        <span>
                          <a-statistic-countdown
                            :value="transitionDate(item.sort_time)"
                            :value-style="{
                              fontSize: '12px',
                              color: '#ffffff',
                              minWidth: '140px',
                            }"
                            format="D 天 H 时 m 分 s 秒"
                          />
                        </span>
                      </span>
                      <span
                        v-if="
                          new Date().valueOf() >
                          moment(item.sort_time).endOf('day').valueOf()
                        "
                      >
                        <!--已结束-->
                        <img
                          :src="imgs"
                          alt=""
                          class="icon"
                          style="margin-top: 2px; color: #dadada"
                        />
                        <span>已结束</span>
                      </span>
                    </span>
                    <span
                      v-if="item.type === 'convention'"
                      style="display: flex"
                    >
                      <span
                        v-if="
                          new Date().valueOf() >
                            new Date(
                              transitionDate(item.sort_time)
                            ).valueOf() &&
                          new Date().valueOf() <
                            moment(item.sort_time).endOf('day').valueOf()
                        "
                      >
                        <!--正在直播-->
                        <img
                          :src="imgOne"
                          alt=""
                          class="icon"
                          style="margin-top: 2px; color: #dadada"
                        />
                      </span>
                      <span
                        v-if="
                          new Date().valueOf() <=
                          new Date(transitionDate(item.sort_time)).valueOf()
                        "
                      >
                        <!--倒计时-->
                        <img
                          :src="imgs"
                          alt=""
                          class="icon"
                          style="margin-top: 2px; color: #dadada; float: left"
                        />
                        <span>
                          <a-statistic-countdown
                            :value="transitionDate(item.sort_time)"
                            :value-style="{
                              fontSize: '12px',
                              color: '#dadada',
                              minWidth: '140px',
                            }"
                            format="D 天 H 时 m 分 s 秒"
                          />
                        </span>
                      </span>
                      <span
                        v-if="
                          new Date().valueOf() >
                          moment(item.sort_time).endOf('day').valueOf()
                        "
                      >
                        <!--已结束-->
                        <img
                          :src="imgs"
                          alt=""
                          class="icon"
                          style="margin-top: 2px; color: #dadada"
                        />
                        <span>已结束</span>
                      </span>
                    </span>
                  </div>
                  <!--会议时间-->
                  <div
                    class="list-time-bottom"
                    style="position: absolute; bottom: 5px"
                  >
                    <span style="margin-left: 5px"
                      >会议时间：{{ item.display_time }}</span
                    >
                  </div>
                </div>
                <div class="list-title">
                  <p class="icon-font">
                    <a-button
                      v-if="item.type === 'convention'"
                      size="small"
                      style="
                        width: 55px;
                        height: 20px;
                        line-height: 20px;
                        font-size: 8px;
                        background-color: #f3964b !important;
                        margin-left: 5px;
                      "
                      type="primary"
                      >多会场
                    </a-button>
                    <a-button
                      v-if="item.type === 'series'"
                      size="small"
                      style="
                        width: 55px;
                        height: 20px;
                        line-height: 20px;
                        font-size: 8px;
                        margin-left: 5px;
                        background-color: #45a5e6 !important;
                        color: white;
                        border: none;
                      "
                      >系列会
                    </a-button>
                    {{ item.title }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!--点播-->
          <div>
            <div class="homePage-list-div-mid">
              <!-- &lt;!&ndash;   字   &ndash;&gt; -->
              <div class="font">
                <div class="font-list">
                  <span class="font-list-live">点播</span>
                  <div class="font-list-div"></div>
                  <span class="font-list-eng">Video</span>
                </div>
              </div>
              <!-- <div class="homePage-list-div-list">
                         <div
                             v-for="(item,index) in cardListTwo"
                             class="homePage-list-div-list-card">
                           <div ><img class="img" :src="item.url"/></div>
                           <div class="list-title">
                             {{item.title}}
                           </div>
                           <div class="list-name">
                             {{item.name}}
                           </div>
                           <div class="list-hos">
                             {{item.hos}}
                           </div>
                         </div>
                       </div> -->
              <!-- list-->
              <div class="homePage2-list-div-list">
                <div style="margin: 0 auto; width: 99%">
                  <div
                    @click="listCardCont(item.id, item)"
                    v-for="(item, index) in cardListTwo"
                    class="homePage2-list-div-list-card"
                  >
                    <div v-if="item.type === 'MIX_SET_TOPIC'">
                      <img
                        class="list-img"
                        :src="item.cover[1]"
                        v-if="item.cover.length !== 1"
                      />
                      <img class="list-img" :src="item.cover[0]" v-else />
                    </div>
                    <div v-else style="position: relative">
                      <img class="list-img" :src="item.cover" />
                      <admin_con type="icon-kaishi" class="icon" />
                    </div>
                    <div class="list-title">
                      {{ item.title }}
                    </div>
                    <div style="display: flex; width: 100%">
                      <!--              左边   -->
                      <div style="width: 73%">
                        <div
                          v-if="item.type === 'MIX_SET_TOPIC'"
                          style="
                            margin-top: 15px;
                            margin-left: 10px;
                            display: flex;
                            font-size: 12px;
                          "
                        >
                          <div>
                            <a-button
                              style="
                                background-color: #ff9d39;
                                color: white;
                                font-size: 12px;
                                border: 0px;
                                margin-top: -8px;
                              "
                              type="primary"
                              size="small"
                              >专题</a-button
                            >
                          </div>
                          <div
                            style="
                              margin-left: 10px;
                              font-size: 12px;
                              color: #9b9b9b;
                            "
                          >
                            共{{ item.vod_count }}个视频
                          </div>
                        </div>
                        <div v-else>
                          <div class="list-time">
                            {{ item.expert.name }}
                          </div>
                          <div class="list-time">
                            {{ item.expert.hospital }}
                          </div>
                        </div>
                      </div>
                      <!--    右边   -->
                      <div class="list-Num">
                        <a-icon type="eye" style="font-size: 12px" />
                        <span style="color: #9b9b9b">
                          {{ item.browse_count }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                style="
                  width: 100%;
                  height: 50px;
                  display: block;
                  display: flex;
                  justify-content: center;
                "
              >
                <!-- <span> -->
                <a style="margin: auto" @click="goPage"
                  >查看更多点播视频<img
                    src="../../assets/右双箭头.png"
                    style="margin-left: 6px; width: 14px; margin-top: -3px"
                    alt=""
                /></a>

                <!-- </span> -->
              </span>

              <!-- <div style="height: 10px;"></div> -->
            </div>
          </div>

          <div class="homePage-list-div-bottom" style="margin-top: 10px">
            <!--   字   -->
            <div
              style="
                display: flex;
                height: 50px;
                line-height: 50px;
                margin-left: 15px;
              "
            >
              <span style="color: black; font-weight: bold">调研</span>
              <div
                style="
                  width: 5px;
                  height: 15px;
                  background-color: #3274cc;
                  margin-left: 10px;
                  margin-right: 10px;
                  margin-top: 18px;
                "
              ></div>
              <span style="color: darkgray">Investigate And Survey</span>
            </div>
            <div style="margin-top: 10px">
              <!-- 盒子 style="display: flex;justify-content: space-between;" -->
              <!-- <div>
                  <div>
                    <img
                        alt=""
                        src='../../assets/ylards.png'
                        style="margin-left: 10px;width: 220px;height: auto;cursor: pointer" @click="hezuo_one_get">
                  </div>
                  <div>
                    <div class="divSty">
                      <a-button @click="openLink('https://www.wjx.cn/vm/OyucThK.aspx#')">
                        参与调研
                      </a-button>
                      <a-button style="margin-left: 10px" @click="()=>{this.visible = true;}">
                        查看详情
                      </a-button>
                    </div>
                  </div>
                </div> -->

              <div class="spanBox">
                <div
                  class="spanBox-row"
                  v-for="(items, index) in SurveyData"
                  :key="items.name"
                >
                  <div style="width: 220px">
                    <img
                      alt=""
                      style="width: 100%; height: 76px; cursor: pointer"
                      :src="items.image"
                      @click="hezuo_one_get(items)"
                    />
                    <!--src='../../assets/ylards.png' @click="hezuo_one_get" -->
                  </div>
                  <div>
                    <div class="divSty">
                      <!--  -->
                      <a-button @click="openLink(items.link, items)">
                        参与调研
                      </a-button>
                      <!--                   <a-button @click="openLink('https://v.xiumi.us/board/v5/22U0a/471454159')" style="margin-left: 10px">-->
                      <!-- @click="()=>{this.visible = true;}" -->
                      <a-button
                        style="margin-left: 10px"
                        @click="Detail(items)"
                      >
                        查看详情
                      </a-button>
                    </div>
                  </div>
                  <!-- <span>{{ setItems.name }}</span>
                     <span>{{ setItems.visitorsNum }}</span> -->
                </div>
              </div>

              <!-- <div style="margin-left: 20px">
                  <div>
                    <img
                        alt=""
                        src='../../assets/hlards.png'
                        style="margin-left: 10px;width: 220px;height: auto;cursor: pointer" @click="hezuo_two_get">
                  </div>
                  <div>
                    <div class="divSty">
                      <a-button @click="openLink('https://www.wjx.cn/vm/YaXIDBB.aspx#')">
                        参与调研
                      </a-button>
                      <a-button style="margin-left: 10px" @click="()=>{this.visibleTwo = true;}">
                        查看详情
                      </a-button>
                    </div>
                  </div>
                </div> -->
              <!-- <div style="margin-left: 0px;display: inline-block;">
                  <div>
                    <img
                        alt=""
                        src='../../assets/jxyxy.png'
                        style="margin-left: 10px;width: 220px;height: auto;cursor: pointer" @click="hezuo_Four_get">
                  </div>
                  <div>
                    <div class="divSty">
                      <a-button @click="openLink('https://www.wjx.cn/vm/OPiIrnc.aspx#')">
                        参与调研
                      </a-button>
                      <a-button style="margin-left: 10px" @click="()=>{this.visibleFour = true;}">
                        查看详情
                      </a-button>
                    </div>
                  </div>
                </div> -->
            </div>
            <div style="height: 10px"></div>
          </div>
          <div class="homePage-list-div-top" style="margin: 10px 0">
            <!--   字   -->
            <div class="font">
              <span class="font-live">投稿</span>
              <div class="font-div"></div>
              <span class="font-eng">Contribute</span>
            </div>
            <ContributeView
              style="padding: 0 20px"
              :contribute-list="contributeList"
            ></ContributeView>
          </div>
        </div>
      </div>
    </a-spin>

    <!--------------------------------    对话框     ---------------------->
    <!-- 医疗查看详情弹窗 -->
    <a-modal
      :footer="null"
      :visible="visible"
      width="800px"
      @cancel="
        () => {
          this.visible = false;
        }
      "
    >
      <div>
        <!-- <div style="text-align: center;margin-bottom: 20px"><h3>山东省中重度ARDS患者俯卧位通气实施情况问卷调查（医疗）</h3></div> -->
        <div style="text-align: center; margin-bottom: 20px">
          <h3>{{ itemTitle }}</h3>
        </div>
        <!-- <div >
          各位同仁：
        </div>
        <div class="textSty">
          {{ itemContent }}
        </div> -->

        <div v-html="itemContent" class="textSty"></div>
      </div>
    </a-modal>
    <!-- 护理查看详情弹窗 （废）-->
    <a-modal
      :footer="null"
      :visible="visibleTwo"
      width="800px"
      @cancel="
        () => {
          this.visibleTwo = false;
        }
      "
    >
      <div>
        <div>
          <div style="text-align: center; margin-bottom: 20px">
            <h3>山东省中重度ARDS患者俯卧位通气实施情况问卷调查（护理）</h3>
          </div>

          <div></div>
          <div class="textSty">
            为了做好提高中重度ARDS俯卧位通气实施率这一质控指标，山东省重症医学专业医疗组质量控制中心专家组设计了一个调查问卷，
            旨在明确目前我省中重度 ARDS
            患者俯卧位通气实施现状，分析影响因素从而研究相关改进办法。
            问卷调查对象为各二级及三级医疗机构全体
            ICU医务人员(此部分为护理问卷)，本问卷为匿名形式，答题时间约 10
            分钟，敬请大家如实填写！感谢您的支持！
          </div>
          <div class="textSty" style="color: red">
            中重度ARDS的定义：在优化通气设置后仍存在PaO2/FiO2＜150mmHg，PEEP≥5cmH2O。
          </div>
        </div>
      </div>
    </a-modal>
    <!-- 第三个-->
    <a-modal
      :footer="null"
      :visible="visibleFour"
      width="800px"
      @cancel="
        () => {
          this.visibleFour = false;
        }
      "
    >
      <div>
        <div>
          <div style="text-align: center; margin-bottom: 20px">
            <h3>2023疑似重症急性胰腺炎问卷调研通知</h3>
          </div>
          <div class="textSty">
            云ICU平台在急危重症领域汇聚了全球顶尖专家，提供医学在线教育、在线会议、学术讨论等服务，是面向全国的医学交流平台。
          </div>
          <div class="textSty">
            急性胰腺炎（acute
            pancreatitis，AP）是临床十分常见的急症，发病率逐年增高，尤其重症急性胰腺炎起病凶险、病死率高，是严重危害人们身体健康的重要病种。
          </div>
          <div class="textSty">
            为了获得相关急性胰腺炎流行病学数据，进一步修改我国的共识意见和指南提供支持；更好地推广急性胰腺炎MDT共识意见，提高重症急性胰腺炎规范化诊疗水平，让更多患者获益，云ICU平台将举办“疑似重症急性胰腺炎问卷调研”活动。
          </div>
          <div class="textSty">现将具体事项通知如下：</div>
          <div class="titleSty">一、调研入选标准</div>
          <div class="textSty">
            在2023年7月1日至2023年10月31日期间收治入院的疑似重症急性胰腺炎患者
          </div>
          <div class="titleSty">二、调研内容</div>
          <div class="textSty">详见调研问卷</div>
          <div class="titleSty">三、投稿方法</div>
          <div class="textSty">识别二维码，直接填写提交</div>
          <div>
            <img
              alt=""
              src="../../assets/two.png"
              style="width: 100px; margin-left: 30px"
            />
          </div>
          <div class="textSty">
            或登录网址提交：<a
              target="_blank"
              href="https://www.wjx.cn/vm/OPiIrnc.aspx#"
              >https://www.wjx.cn/vm/OPiIrnc.aspx#</a
            >
          </div>
          <div class="titleSty">四、截止日期</div>
          <div class="textSty">调研截止至2023年10月31日。</div>
          <div class="textSty">
            调研问卷一经录用，将获得云ICU平台的奖励。本活动最终解释权由云ICU所有。如有任何疑问，请发邮件至service@yunicu.com联系。谢谢。
          </div>
          <div style="text-align: right">2023年6月</div>
          <div style="display: flex; justify-content: right; margin-top: 10px">
            <img alt="" src="../../assets/twoFoot.png" style="width: 100px" />
          </div>
        </div>
      </div>
    </a-modal>
    <Login :loginVisible="loginVisible" @loginCancel="loginCancel"></Login>
  </div>
</template>
<script>
import { getContribute, getOfficalSurvey } from "@/service/api";
import { geBannerList2, geLiveList, geBannerList3 } from "@/service/api_fire";
import { postBannerMaiDian, reportpageConten } from "@/service/api";
import { getVodMostBrowse } from "@/service/myInfo";
import moment from "moment";
import { getAdmins } from "@/util/adminDate";
import { getUserInfo } from "@/util/userInfo";
import Login from "@/components/login.vue";
import ContributeView from "@/components/contributeView.vue";
import { getSystem } from "@/util/systemOA";
export default {
  components: {
    Login,
    ContributeView,
  },
  data() {
    return {
      getSystem: getSystem(),
      visible: false,
      visibleTwo: false,
      visibleFour: false,
      test: "12px",
      spinning: false,
      imageStr: [],
      cardList: [],
      cardListTwo: [],
      imgOne: require("../../assets/liveIng.gif"),
      imgs: require("../../assets/iconLive.png"),
      test1: "2022-07-31",
      loginVisible: false,
      length: "",
      SurveyData: [],
      itemTitle: "",
      itemContent: "",
      num: 0,
      //用户登录token
      token: window.localStorage.getItem("user_info")
        ? JSON.parse(window.localStorage.getItem("user_info")).id
        : "",
      contributeList: [], //投稿
    };
  },
  mounted() {},
  created() {
    this.getBannerImg();
    this.getlist();
    this.OfficalSurvey();
    this.getContributeList();
    this.getVideo();
    if (this.token === null || this.token === "" || !this.token) {
      this.login = false;
    } else {
      this.login = true;
    }
  },
  methods: {
    async getVideo() {
      this.spinning = true;
      const response = await getVodMostBrowse("10");
      if (response.code === 0) {
        this.cardListTwo = response.data;
      } else {
        this.$message.warning(response.message);
      }
      this.spinning = false;
    },
    Detail(items) {
      this.visible = true;
      this.itemTitle = items.title;
      this.itemContent = items.content;
    },
    async OfficalSurvey() {
      const response = await getOfficalSurvey("", "", "", 999, 1);
      // console.log("请求",response)
      if (response.code === 0) {
        this.length = response.data.total;
        this.SurveyData = response.data.list;
        // // console.log("看看长度",response.data.list.length)
        // this.total = response.data.total
      } else {
        this.$message.warning(response.message);
      }
    },

    openLink(url, item) {
      // 仅注释暂不删除
      // if(item.isLogin == 0 || this.token !== null || this.token !== '' || this.token){
      //   window.open(url)
      //   this.$store.commit('isLoginStatus', '')
      // }else if(item.isLogin == 1 ||this.token === null || this.token === '' || !this.token){
      //   this.num++
      //   this.$store.commit('isLoginStatus', this.num)
      // }
      // 如果调研卡片的登录状态为0或者是已经在登录的状态了，就允许跳转
      if (item.isLogin == 0 || this.token) {
        window.open(url);
        this.$store.commit("isLoginStatus", "");
      } else if (item.isLogin == 1) {
        //否则先登录
        this.num++;
        this.$store.commit("isLoginStatus", this.num);
      }
    },
    openLinkDetail(title) {
      this.detailTitle = title;
      this.visible = true;
    },
    transitionDate(date) {
      var date = new Date(date).toJSON();
      //console.log(ate);//可打印查看
      // 将输入的日期格式化成中国标准时间 “Mon Jul 19 2021 11:11:55 GMT+0800 (中国标准时间)”
      var date = new Date(date);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      var Time = y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
      return Time;
    },
    moment,
    //获取banner
    async getBannerImg() {
      this.spinning = true;
      // const response = await geBannerList('YUN_ICU')
      const response = await geBannerList3({
        code: "YUN_ICU",
        bannerLocation: "web",
      });
      if (response.code === 0) {
        this.imageStr = response.data;
      } else {
        this.$message.warning(response.message);
      }
      this.spinning = false;
    },

    //获取直播列表
    async getlist() {
      this.spinning = true;
      // let data = {
      //   domain_code:'yunicu'
      // }
      let { os } = await getAdmins("1"); // 获取埋点数据
      if (os === "windows") {
        os = "web_windows";
      } else if (os === "mac") {
        os = "web_mac";
      }
      // let data = {
      //   "x-client-tag": os,
      // };
      // const { user_id } = getUserInfo("user_id");
      const response = await geLiveList();
      if (response.code === 0) {
        this.cardList = response.data;
      } else {
        this.$message.warning("失败" + response.message);
      }
      this.spinning = false;
    },

    moreBtn() {
      this.$message.success("hello");
    },
    async starRunLive(getUrl, id) {
      const md = await getAdmins("1"); // 获取埋点数据
      await postBannerMaiDian(
        md.channel,
        md.os,
        md.ip,
        md.version,
        id,
        "WEB_INDEX",
        "BANNER"
      ); // 添加埋点数据
      if (!getUrl || getUrl === "") return;
      // window.open(getUrl)
      if (this.token === null || this.token === "" || !this.token) {
        this.loginVisible = true;
      } else {
        const userInfo = window.localStorage.getItem("user_info")
          ? JSON.parse(window.localStorage.getItem("user_info"))
          : "";
        if (decodeURIComponent(getUrl).indexOf("?") !== -1) {
          window.open(
            getUrl + "&memberId=" + userInfo.user_id + "&channel=web"
          );
        } else {
          window.open(
            getUrl + "?memberId=" + userInfo.user_id + "&channel=web"
          );
        }
      }
    },
    hezuo_one_get(items) {
      //急性缺血性脑卒中问卷调研-高潜
      window.open(items.link);
    },
    hezuo_two_get() {
      //重症急性胰腺炎预防与阻断
      window.open("https://www.wjx.cn/vm/YaXIDBB.aspx#");
    },
    hezuo_Four_get() {
      //重症急性胰腺炎预防与阻断
      window.open("https://www.wjx.cn/vm/OPiIrnc.aspx#");
    },
    roomBtn_link(url) {
      window.open(url);
    },
    onFinish() {
      console.log("finished!");
    },
    loginCancel() {
      // 登录窗口关闭
      this.loginVisible = false;
    },

    async getContributeList() {
      const info = await getContribute();
      if (info.code === 0) {
        this.contributeList = info.data;
      }
    },
    listCardCont(id, row) {
      if (this.login === false) {
        this.loginVisible = true;
        return;
      }
      if (row.type === "VOD_SINGLE") {
        this.BrowseHistory(row.type, id, "INDEX_VOD_SINGLE");
        //点播详情
        this.$router.push({
          path: "/detailsDemand",
          query: { id: id, login: this.login, index: "index" },
        });
      } else {
        this.BrowseHistory(row.type, id, "INDEX_MIX_SET_TOPIC");
        //专题详情
        this.$router.push({
          path: "/projectDetails",
          query: { id: id, login: this.login, index: "index" },
        });
      }
    },
    goPage() {
      this.$router.push({
        path: "/PointLive",
        // query: { id: id, login: this.login,index :"index" },
      });
    },
    // 点播埋点
    async BrowseHistory(type, id, location) {
      let memberId = window.localStorage.getItem("user_info")?JSON.parse(window.localStorage.getItem("user_info")).id:'';
      let data = {
        type: "index", //index表示在首页列表中点击，mix_index表示在专题列表中点击
        contentId: Number(id), //为vod时，根据contentId增加浏览量
        contentType: type,
        location: location, //埋点位置
        // remark: list.parent_id, //为专题视频时，记录所属专题id
        channel: "web",
        os: this.getSystem,
        memberId: memberId,
      };
      // }
      const res = await reportpageConten(data);
      if (res.code == 0) {
        // console.log("埋点")
        // this.load();
        // this.location = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:global.ant-statistic-content {
  font-size: 12px !important;
}

.homePage {
  height: auto;
  width: 100%;
  overflow: auto;
  display: inline-block;

  .homePage-img {
    width: 100%;
    margin: auto;
    background-image: url("../../assets/bgc.png");
    height: 300px;
  }

  .homePage-list {
    width: 100%;
    display: inline-block;
    background-image: url("../../assets/bgc.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .homePage-list-div {
      width: 70%;
      margin: auto;

      .homePage-list-div-top {
        width: 100%;
        display: inline-block;
        background-color: #fff;
        border-radius: 5px;

        .font {
          display: flex;
          height: 50px;
          line-height: 50px;
          margin-left: 15px;

          .font-live {
            color: black;
            font-weight: bold;
          }

          .font-div {
            width: 5px;
            height: 15px;
            background-color: #3274cc;
            margin-left: 10px;
            margin-right: 10px;
            margin-top: 18px;
          }

          .font-eng {
            color: darkgray;
          }
        }

        .homePage-list-div-list {
          width: 100%;
          display: inline-block;
          padding: 0 20px;
          .homePage-list-div-list-card {
            width: 23%;
            float: left;
            cursor: pointer;
            min-height: 200px;
            //height: auto;
            border: 1px solid #e8e8e8;
            //margin-left: 1%;
            margin-right: 1%;
            margin-bottom: 1%;

            .list-img {
              width: 100%;
              height: auto;
            }

            .list-title {
              width: 100%;
              min-height: 50px;
              color: #333333;

              .icon-font {
                font-weight: bold;
                font-size: 14px;
                margin: auto;
                padding-top: 5px;
                display: -webkit-box;
                text-overflow: ellipsis;
                overflow: hidden;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                word-break: break-all;
              }
            }

            .list-time {
              background-color: #000;
              width: 100%;
              height: 20px;
              background: -webkit-linear-gradient(
                top,
                rgb(0, 0, 0, 0.5),
                rgba(69, 68, 68, 0.2),
                rgba(255, 255, 255, 0)
              );
              color: #ffffff;
              font-size: 10px;
              margin: auto;
              min-height: 20px;

              .icon {
                color: #dadada;
                width: 13px;
                height: 13px;
                margin-right: 5px;
              }
            }

            .list-time-bottom {
              background-color: #000;
              width: 100%;
              height: 20px;
              background: -webkit-linear-gradient(
                top,
                rgba(255, 255, 255, 0),
                rgba(69, 68, 68, 0.2),
                rgb(0, 0, 0, 0.5)
              );
              color: #ffffff;
              font-size: 10px;
              margin: auto;
              min-height: 20px;
            }
          }
        }
      }

      .homePage-list-div-mid {
        display: inline-block;
        width: 100%;
        border-bottom: 10px solid #f5f5f5;
        border-top: 10px solid #f5f5f5;
        background-color: #fff;
        border-radius: 5px;

        .font {
          display: flex;
          height: 50px;
          line-height: 50px;
          margin-left: 15px;

          .font-list {
            display: flex;
            height: 50px;
            line-height: 50px;
            width: 50%;

            .font-list-live {
              color: black;
              font-weight: bold;
            }

            .font-list-div {
              width: 5px;
              height: 15px;
              background-color: #3274cc;
              margin-left: 10px;
              margin-right: 10px;
              margin-top: 18px;
            }

            .font-list-eng {
              color: darkgray;
            }
          }

          .font-list-more {
            color: #999999;
            width: 48%;
            text-align: right;
            font-size: 10px;
            cursor: pointer;
          }

          .font-list-more:hover {
            color: #3274cc;
          }
        }

        .homePage-list-div-list {
          width: 100%;
          display: inline-block;

          .homePage-list-div-list-card {
            width: 23%;
            float: left;
            border: 1px solid #e8e8e8;
            margin-left: 1%;
            margin-right: 1%;
            margin-bottom: 1%;

            .img {
              width: 100%;
              height: auto;
            }

            .list-title {
              width: 90%;
              color: #333333;
              font-weight: bold;
              font-size: 14px;
              margin: auto;
              padding-top: 5px;
              display: -webkit-box;
              text-overflow: ellipsis;
              overflow: hidden;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              word-break: break-all;
            }

            .list-name {
              width: 90%;
              color: #9b9b9b;
              font-size: 8px;
              margin: auto;
              padding-top: 5px;
            }

            .list-hos {
              width: 90%;
              color: #9b9b9b;
              font-size: 8px;
              margin: auto;
            }
          }
        }
      }

      .homePage-list-div-bottom {
        //display: inline-block;
        min-height: 150px;
        background-color: #fff;
        border-radius: 5px;
      }
    }
  }
}

.divSty {
  //margin-top: 10px;
  //margin-left: 10px;
  border: 1px solid #dbd9d9;
  height: 70px;
  width: 220px;
  //display: flex;
  text-align: center;
  line-height: 70px;
}

.textSty {
  line-height: 1.5;
  text-indent: 2em;
  margin-bottom: 6px;
}

.titleSty {
  margin-bottom: 6px;
  margin-top: 6px;
  font-weight: bold;
}

.spanBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 0 20px;
}
.spanBox-row {
  //width: 25%;
  margin: 0 5px 5px 0;
}
.homePage2-list-div-list {
  width: 100%;
  display: inline-block;
  margin-top: -20px;
  .homePage2-list-div-list-card {
    width: 17.9%;
    float: left;
    height: 219px;
    border: 1px solid #e8e8e8;
    margin-left: 1%;
    margin-right: 1%;
    cursor: pointer;
    margin-top: 20px;
    .icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: auto;
      font-size: 40px;
    }
    .list-img {
      width: 100%;
      height: 120px; /////////////150
    }
    .list-title {
      height: 48px;
      width: 90%;
      color: #333333;
      font-weight: bold;
      font-size: 14px;
      margin: auto;
      padding-top: 7px;
      //显示两行标题，其他省略号显示
      display: -webkit-box;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
    }
    .list-time {
      width: 97%;
      color: #9b9b9b;
      font-size: 12px;
      margin: auto;
      padding: 0px 0px 0px 10px;
    }
    .list-Num {
      width: 20%;
      line-height: 45px;
      font-size: 11px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .icon {
        font-size: 15px;
      }
    }
  }
}
</style>
